import React from "react";
import { Mail, Phone, MapPin } from "lucide-react"; // lucide-react icons

const ContactUs = () => {
  return (
    <section className="w-full min-h-screen bg-[#F8FAFC] flex flex-col md:flex-row p-10 max-sm:p-5">
      {/* Left Section */}
      <div className="flex-1 flex flex-col justify-center px-6 md:px-12 max-sm:px-0 py-12">
        {/* Heading */}
        <h2 className="text-3xl sm:text-4xl font-bold text-[#012D6F] mb-3">
          Get in Touch With<br /> 
          <span className="text-[#E43038]">4 Aviators</span>
        </h2>

        {/* Description */}
        <p className="text-gray-700 text-base sm:text-lg mb-8 leading-relaxed">
          We’re here to help you start your aviation journey. Drop us a message,
          visit our hangar, or schedule a call - we’ll get back to you shortly.
        </p>

        {/* Contact Form */}
        <form className="space-y-5 bg-white p-5 rounded-xl">
          <div>
            <label className="block text-gray-800 mb-2 font-medium">Name</label>
            <input
              type="text"
              placeholder="Enter your name"
              className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-[#012D6F]"
            />
          </div>
          <div>
            <label className="block text-gray-800 mb-2 font-medium">Email</label>
            <input
              type="email"
              placeholder="Enter your email"
              className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-[#012D6F]"
            />
          </div>
          <div>
            <label className="block text-gray-800 mb-2 font-medium">Message</label>
            <textarea
              rows="4"
              placeholder="Type your message..."
              className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-[#012D6F]"
            ></textarea>
          </div>
          <button
            type="submit"
            className="bg-[#2C2C2C] hover:bg-[#393939] text-white px-6 py-3 rounded-lg font-semibold transition-all duration-300 w-full"
          >
            Submit
          </button>
        </form>

        {/* Contact Details */}
        <div className="mt-10 space-y-4">
          <div className="flex items-center gap-3">
            <Mail className="text-[#012D6F]" />
            <p className="text-gray-800">info@4aviators.com</p>
          </div>
          <div className="flex items-center gap-3">
            <Phone className="text-[#012D6F]" />
            <p className="text-gray-800">0+27 73 505 7012</p>
          </div>
          <div className="flex items-start gap-3">
            <MapPin className="text-[#012D6F] mt-1" />
            <p className="text-gray-800 leading-relaxed">
              General Aviation Area,<br />
              5 Convair Rd, Cape Town International Airport,<br />
              Cape Town, 7490, South Africa
            </p>
          </div>
        </div>
      </div>

      {/* Right Section (Image) */}
      <div className="flex-1">
        <img
          src="https://mhcockpit.com/Media/4%20Aviators/Contact/Contact-img.jpg"
          alt="Aviation"
          className="w-full h-full object-cover rounded-3xl"
        />
      </div>
    </section>
  );
};

export default ContactUs;
